import { PartnersHeroAdapter as PartnersHero } from "./PartnersHero";

export { PartnersHero };
